export const getterTypes = {
	contactsSkeleton: 'contactsSkeleton',
	contactsItems: 'contactsItems',
	contactsValidation: 'contactsValidation'
};

export default {
	[getterTypes.contactsSkeleton]: state => ({...state.skeleton}),		
	[getterTypes.contactsItems]: state => state.items, 
	[getterTypes.contactsValidation]: state => state.validation
};